import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "query-input-container" }

import { ref, nextTick, inject } from "vue";
import Card from 'primevue/card';
import Button from 'primevue/button';
import ContainedTextArea from '../misc/ContainedTextArea.vue';

import { BeakerSession } from 'beaker-kernel/src';
import { type BeakerSessionComponentType } from '../session/BeakerSession.vue';
import { type BeakerNotebookComponentType } from '../notebook/BeakerNotebook.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BeakerAgentQuery',
  props: [
    "runCellCallback"
],
  emits: [
    "select-cell",
    "run-cell",
],
  setup(__props, { emit: __emit }) {

const props = __props;

const beakerSession = inject<BeakerSessionComponentType>("beakerSession");
const notebook = inject<BeakerNotebookComponentType>("notebook");

const query = ref("");
const emit = __emit;

const session: BeakerSession = inject("session");

const handleQuery = (e: any) => {
    if (!query.value.trim()) {
        return; // TODO notify user that they're missing the agent query?
    }

    // Remove the top cell if it is blank/not used.
    if (notebook.notebook.cells.length === 1) {
        const existingCell = notebook.notebook.cells[0];
        if (
            existingCell.cell_type === "code" && existingCell.source === ""
            && existingCell.execution_count === null && existingCell.outputs.length === 0
        ) {
            notebook.notebook.removeCell(0);
        }
    }
    const cell = session.addQueryCell(query.value);
    query.value = "";

    nextTick(() => {
        notebook.selectCell(cell.id);
        beakerSession.findNotebookCellById(cell.id).execute();
    });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "agent-input-card" }, {
    title: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode(" How can the agent help? ")
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ContainedTextArea, {
          onSubmit: handleQuery,
          modelValue: query.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          style: {"flex":"1","margin-right":"0.75rem"},
          placeholder: "Ask the AI or request an operation."
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(Button), {
          onClick: handleQuery,
          class: "agent-submit-button",
          icon: "pi pi-reply",
          label: "enter"
        })
      ])
    ]),
    _: 1
  }))
}
}

})